import { render } from "./ScrollPicker.vue?vue&type=template&id=8b03f948&bindings={}"
import script from "./ScrollPicker.vue?vue&type=script&lang=ts"
export * from "./ScrollPicker.vue?vue&type=script&lang=ts"

import "./ScrollPicker.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script